import * as React from 'react'
import Svg, { Path } from 'react-native-svg'
export const AlertIcon = () => (
  <Svg width={24} height={24} viewBox='0 0 24 24' fill='none'>
    <Path
      d='M12 21.75C13.1 21.75 14 20.85 14 19.75H10C10 20.85 10.9 21.75 12 21.75ZM18 15.75V10.75C18 7.68 16.37 5.11 13.5 4.43V3.75C13.5 2.92 12.83 2.25 12 2.25C11.17 2.25 10.5 2.92 10.5 3.75V4.43C7.64 5.11 6 7.67 6 10.75V15.75L4 17.75V18.75H20V17.75L18 15.75ZM16 16.75H8V10.75C8 8.27 9.51 6.25 12 6.25C14.49 6.25 16 8.27 16 10.75V16.75Z'
      fill='white'
    />
  </Svg>
)
